module.exports = __webpack_public_path__ + "img/AppointmentInfo.614d6c12.svg";